'use strict';

import { Detector } from '@detector-js/detector';

export { Detector };
